import React, { useState, useEffect } from 'react';
import { ReactComponent as IconWallet } from '../../assets/icons/icon-awesome-wallet.svg';
import ButtonPrimary from '../misc/ButtonPrimary';
import Cash from './Payment/Cash';
import Ewallet from './Payment/Ewallet';
import Transfer from './Payment/Transfer';

const ListMenu = (props) => {
  return (
    <>
      <div className="flex flex-col my-1">
        <h5 className="mb-3">Dompet</h5>
        <button className="pl-8 pr-6 py-5 border border-transparant hover:border-orange-500 flex flex-col items-start rounded">
          <div className="flex w-full">
            <span className="flex mr-4">
              <IconWallet className="w-5 h-5" />
            </span>
            <p>Rp. 360.000</p>
            <label className="flex items-center ml-auto">
              <input
                type="checkbox"
                className="form-checkbox rounded-full bg-gray-300 "
              />
            </label>
          </div>
          <p className="capitalize text-basic-orange pt-2 mt-2 border-t border-gray-300 w-full text-left">
            Isi Saldo
          </p>
        </button>
      </div>
      <div className="flex flex-col my-1">
        <h5 className="mb-3 capitalize">Tunai</h5>
        <button
          className="pl-8 pr-6 py-5 border border-gray-400 hover:border-orange-500 flex items-center rounded"
          onClick={props.handleCash}
        >
          <p className="capitalize">Pilih Pembayaran Tunai</p>
          <svg
            className="w-6 h-6 ml-auto my-auto"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5l7 7-7 7"
            ></path>
          </svg>
        </button>
      </div>
      <div className="flex flex-col my-1">
        <h5 className="mb-3 capitalize">Transfer</h5>
        <button
          className="pl-8 pr-6 py-5 border border-gray-400 hover:border-orange-500 flex items-center rounded"
          onClick={props.handleTransfer}
        >
          <p className="capitalize">Pilih Pembayaran Transfer</p>
          <svg
            className="w-6 h-6 ml-auto my-auto"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5l7 7-7 7"
            ></path>
          </svg>
        </button>
      </div>
      <div className="flex flex-col my-1">
        <h5 className="mb-3 capitalize">E-Wallet</h5>
        <button
          className="pl-8 pr-6 py-5 border border-gray-400 hover:border-orange-500 flex items-center rounded"
          onClick={props.hadleWallet}
        >
          <p className="capitalize">Pilih Pembayaran E-Wallet</p>
          <svg
            className="w-6 h-6 ml-auto my-auto"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5l7 7-7 7"
            ></path>
          </svg>
        </button>
      </div>
    </>
  );
};
const ModalPayment = (props) => {
  const [showListMenu, setShowListMenu] = useState(true);
  const [showListCash, setShowListCash] = useState(false);
  const [showListTransfer, setShowListTransfer] = useState(false);
  const [showListHowToTransfer, setShowListHowToTransfer] = useState(false);
  const [showListWallet, setShowListWallet] = useState(false);
  const handleHowToTransfer = () => {
    setShowListTransfer(!showListTransfer);
    setShowListHowToTransfer(!showListHowToTransfer);
  };
  const handleWallet = () => {
    setShowListMenu(!showListMenu);
    setShowListWallet(!showListWallet);
  };
  const handleCash = () => {
    setShowListMenu(!showListMenu);
    setShowListCash(!showListCash);
  };
  const handleTransfer = () => {
    setShowListMenu(!showListMenu);
    setShowListTransfer(!showListTransfer);
  };
  let nameBank = null;
  console.log('Name bank ', nameBank);
  // Overflow hidden
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => (document.body.style.overflow = 'unset');
  }, []);
  return (
    <div className="modal fixed w-full min-h-screen top-0 left-0 flex items-center justify-center z-20 overflow-hidden">
      <div className="modal-overlay absolute w-full h-full bg-gray-900 opacity-50 overflow-hidden"></div>
      <form className="modal-container bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto">
        <div className="modal-content items-center p-6 text-left">
          <div className="flex mb-4 relative justify-center">
            <h4>Pilih Pembayaran</h4>
            <button
              className="px-2 absolute right-0"
              onClick={props.handdleCloseModal}
            >
              X
            </button>
          </div>
          <div className="flex flex-col w-full">
            {/* Menu One */}
            {showListMenu && (
              <ListMenu
                hadleWallet={handleWallet}
                handleCash={handleCash}
                handleTransfer={handleTransfer}
              />
            )}
            {showListCash && <Cash />}
            {showListTransfer && (
              <Transfer handleHowToTransfer={props.handdleHowToTransfer} />
            )}

            {showListWallet && <Ewallet />}
          </div>
          <ButtonPrimary
            handdleClick={props.handdleClickConfirm}
            text="sm"
            addClass={'w-full'}
          >
            Lanjutkan
          </ButtonPrimary>
        </div>
      </form>
    </div>
  );
};

export default ModalPayment;
